import React from 'react'
import { Row, Col } from 'reactstrap'

/* eslint-disable */
import { observer, inject } from 'mobx-react'
/* eslint-enable */

import Sidebar from '../Sidebar'
import access from '../../../../utils/access'

@inject('Community', 'Auth', 'User')
@observer
export class CommunityContainer extends React.Component {
  componentWillMount() {
    const comId = this.props.match.params.comId
    const _findCommunities = () => {
      return setTimeout(() => {
        if (this.props.Auth.token.pending || this.props.User.me.pending) {
          return _findCommunities()
        }

        Promise.all([
          ...(access.adminCom(this.props.User.me.permissions || {})
            ? [this.props.Community.getAllCommunities()]
            : []),
          ...(!this.props.Community.all.slice().find(c => c.id === comId)
            ? [this.props.Community.getCommunity(comId)]
            : []),
          this.props.Community.getMyCommunities()
        ])
      }, 500)
    }

    _findCommunities()
  }

  componentWillReceiveProps(newProps) {
    if (newProps.match.params.comId !== this.props.match.params.comId) {
      this.props.Community.getCommunity(newProps.match.params.comId)
    }
  }

  onCommunityChange(e) {
    const url = Object.keys(this.props.match.params).reduce(
      (_url, key) => _url.replace(`:${key}`, this.props.match.params[key]),
      [
        ...this.props.match.path
          .replace(':comId', e.target.value)
          .split('/')
          .slice(0, -1)
      ].join('/')
    )

    return this.props.history.push(url)
  }

  render() {
    const comId = this.props.match.params.comId
    const community =
      this.props.Community.all.slice().find(a => a.id === comId) || {}

    return (
      <Row>
        <Col xs="12" lg="3">
          <Sidebar
            comId={comId}
            userId={this.props.Auth.token.userId}
            isMod={access.modCom(this.props.User.me.permissions || {})}
            hide={this.props.hide}
            location={this.props.location}
            communities={this.props.Community.all.slice()}
            community={community}
            groups={this.props.Community.groups[comId] || []}
            onCommunityChange={this.onCommunityChange.bind(this)}
          />
        </Col>
        <Col>
          <Row>
            <Col lg="1" className={`d-none d-lg-block`} />
            <Col>{this.props.children}</Col>
          </Row>
        </Col>
      </Row>
    )
  }
}

export default CommunityContainer



// WEBPACK FOOTER //
// ./src/components/Community/partials/Container/index.js